import React from 'react';
import { useOrderDetails } from 'components/context/order_details';
import { ADDRESS_LINE_3_FIRST, isFeatureEnabled } from 'utilities/features';
import { DATADOG_PRIVACY_LEVELS } from 'constants/enums';

const MaskedHTMLParagraph = (props) => {
  return <p data-dd-privacy={DATADOG_PRIVACY_LEVELS.MASK}>{props.children}</p>;
};

const AddressSummary = (props) => {
  const { store } = useOrderDetails();

  const { address } = props;

  const addressLine3First = isFeatureEnabled(ADDRESS_LINE_3_FIRST);

  switch (store) {
    case 'ES': // same as FR
    case 'FR': {
      return (
        <>
          <MaskedHTMLParagraph>
            {address.first_name} {address.last_name}
          </MaskedHTMLParagraph>
          {address.address_line_3 && addressLine3First && (
            <MaskedHTMLParagraph>{address.address_line_3}</MaskedHTMLParagraph>
          )}
          <MaskedHTMLParagraph>{address.address_line_1}</MaskedHTMLParagraph>
          {address.address_line_2 && (
            <MaskedHTMLParagraph>{address.address_line_2}</MaskedHTMLParagraph>
          )}
          {address.address_line_3 && !addressLine3First && (
            <MaskedHTMLParagraph>{address.address_line_3}</MaskedHTMLParagraph>
          )}
          <MaskedHTMLParagraph>
            {address.postal_code} {address.locality}
          </MaskedHTMLParagraph>
        </>
      );
    }
    case 'JP': {
      return (
        <>
          <MaskedHTMLParagraph>
            {address.last_name} {address.first_name}
          </MaskedHTMLParagraph>
          {address.address_line_3 && addressLine3First && (
            <MaskedHTMLParagraph>{address.address_line_3}</MaskedHTMLParagraph>
          )}
          <MaskedHTMLParagraph>〒{address.postal_code}</MaskedHTMLParagraph>
          <MaskedHTMLParagraph>
            {address.administrative_district_level_1}
          </MaskedHTMLParagraph>
          <MaskedHTMLParagraph>{address.locality}</MaskedHTMLParagraph>
          <MaskedHTMLParagraph>{address.address_line_1}</MaskedHTMLParagraph>
          {address.address_line_2 && (
            <MaskedHTMLParagraph>{address.address_line_2}</MaskedHTMLParagraph>
          )}
          {address.address_line_3 && !addressLine3First && (
            <MaskedHTMLParagraph>{address.address_line_3}</MaskedHTMLParagraph>
          )}
        </>
      );
    }
    default: {
      return (
        <>
          <MaskedHTMLParagraph>
            {address.first_name} {address.last_name}
          </MaskedHTMLParagraph>
          {address.address_line_3 && addressLine3First && (
            <MaskedHTMLParagraph>{address.address_line_3}</MaskedHTMLParagraph>
          )}
          <MaskedHTMLParagraph>{address.address_line_1}</MaskedHTMLParagraph>
          {address.address_line_2 && (
            <MaskedHTMLParagraph>{address.address_line_2}</MaskedHTMLParagraph>
          )}
          {address.address_line_3 && !addressLine3First && (
            <MaskedHTMLParagraph>{address.address_line_3}</MaskedHTMLParagraph>
          )}
          <MaskedHTMLParagraph>
            {address.locality}, {address.administrative_district_level_1}
          </MaskedHTMLParagraph>
          <MaskedHTMLParagraph>{address.postal_code}</MaskedHTMLParagraph>
        </>
      );
    }
  }
};

export default AddressSummary;
